import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { NonProductiveManufacturingOrderCategoryBuilder } from '../../models/builders/non-productive-manufacturing-order-category.builder';

@Injectable()
export class NonProductiveManufacturingOrderCategoryApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }non-productive-manufacturing-order-categories`;
  }

  getNonProductiveManufacturingOrderCategories() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(
        map(NonProductiveManufacturingOrderCategoryBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/non-productive-manufacturing-order-category-api.service.ts